import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { STORE } from "../lib/store";

export const Visit = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <section id="visit" ref={ref} className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32">
      <SectionHead kicker="Visit the shop" title={<>Lights on, <em className="text-[#D62828]">fridges cold.</em></>} />
      <div className="grid gap-5 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <div className="relative h-[420px] overflow-hidden rounded-2xl border border-black/10 md:h-full md:min-h-[520px]">
            <motion.img style={{ y }} src="/img/store.jpg" alt="Shopfront at night" className="absolute inset-0 h-[120%] w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6" data-testid="guna-store-address-card">
              <MapPin className="mb-3 h-5 w-5 text-[#FFC93C]" />
              <p className="font-display text-3xl text-white md:text-4xl">{STORE.address}</p>
              <p className="font-mono-g mt-2 text-xs uppercase tracking-[0.2em] text-white/80">United Kingdom</p>
            </div>
          </div>
        </Reveal>
        <div className="flex flex-col gap-5 lg:col-span-5">
          <Reveal delay={0.1} className="rounded-2xl border border-black/10 bg-[#FFFBEB] p-7">
            <p className="font-mono-g mb-5 text-xs uppercase tracking-[0.3em] text-[#D62828]">Opening hours</p>
            <table className="w-full" data-testid="guna-store-hours-table">
              <tbody>
                {STORE.hours.map((h) => (
                  <tr key={h.day} className="border-b border-black/10 last:border-0">
                    <td className="py-4 text-[#1C1917]">{h.day}</td>
                    <td className="font-mono-g py-4 text-right text-sm text-stone-700">{h.time}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Reveal>
          <Reveal delay={0.2} className="rounded-2xl border border-black/10 bg-[#FFC93C] p-7">
            <p className="font-mono-g mb-5 text-xs uppercase tracking-[0.3em] text-[#1C1917]/80">Get in touch</p>
            <p className="flex items-center gap-3 py-2 text-[#1C1917]" data-testid="guna-store-phone"><Phone className="h-4 w-4" /> {STORE.phone}</p>
            <p className="flex items-center gap-3 py-2 text-[#1C1917]" data-testid="guna-store-email"><Mail className="h-4 w-4" /> {STORE.email}</p>
            <p className="mt-4 text-sm text-[#1C1917]/85">Click &amp; collect orders are held for you in store. We operate Challenge 25 — please bring ID.</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
